'use strict';

module.exports.autodetect = require('./autodetect');
module.exports.string = require('./string');
module.exports.object = require('./object');
module.exports.json = require('./json');



//////////////////
// WEBPACK FOOTER
// ./src/parse/source/index.js
// module id = 18
// module chunks = 0